import React, { useState } from "react";
import SellerAccountForm from "./SellerAccountForm";
import SellerLoginForm from "./SellerLoginForm";
import { Button, Box, Typography } from "@mui/material";
import StorefrontIcon from "@mui/icons-material/Storefront";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";

const BecomeSeller = () => {
  const [isLogin, setIsLogin] = useState(true);

  const handleToggleView = () => {
    setIsLogin((prev) => !prev);
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4 sm:p-6 lg:p-8">
      <div className="w-full max-w-5xl bg-white rounded-3xl shadow-xl border border-slate-100 overflow-hidden grid grid-cols-1 lg:grid-cols-12 min-h-[650px]">
        {/* Left Hero / Brand Banner */}
        <div className="lg:col-span-5 bg-gradient-to-br from-slate-900 via-slate-800 to-teal-900 p-8 sm:p-12 text-white flex flex-col justify-between relative overflow-hidden">
          <div className="relative z-10 space-y-6">
            <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-teal-500/10 border border-teal-500/20 text-teal-400 text-xs font-semibold">
              <StorefrontIcon fontSize="small" /> Seller Merchant Portal
            </div>
            <div>
              <Typography variant="h3" className="font-extrabold tracking-tight text-3xl sm:text-4xl text-white">
                {isLogin ? "Welcome Back!" : "Grow Your Business"}
              </Typography>
              <Typography variant="body2" className="text-slate-300 mt-3 text-sm leading-relaxed">
                {isLogin
                  ? "Access your dashboard, manage product catalogs, view real-time orders, and track revenue."
                  : "Join thousands of successful merchants. Set up your store in minutes and start selling today."}
              </Typography>
            </div>
          </div>

          <div className="relative z-10 pt-8 border-t border-slate-700/50 flex items-center gap-3">
            <div className="p-2.5 rounded-xl bg-teal-500/20 text-teal-400">
              <RocketLaunchIcon />
            </div>
            <div>
              <p className="text-xs font-bold text-white uppercase tracking-wider">Fast & Secure Setup</p>
              <p className="text-xs text-slate-400">Integrated local payments & analytics</p>
            </div>
          </div>
        </div>

        {/* Right Form Container */}
        <div className="lg:col-span-7 p-6 sm:p-10 flex flex-col justify-center">
          {isLogin ? <SellerLoginForm /> : <SellerAccountForm />}

          <Box className="mt-8 pt-6 border-t border-slate-100 text-center flex flex-col sm:flex-row items-center justify-center gap-3">
            <Typography variant="body2" className="text-slate-500 font-medium">
              {isLogin ? "Don't have a seller account yet?" : "Already registered as a seller?"}
            </Typography>
            <Button
              onClick={handleToggleView}
              variant="text"
              className="text-teal-600 hover:text-teal-700 font-bold capitalize p-0 min-w-0"
            >
              {isLogin ? "Create Seller Account" : "Sign In to Portal"}
            </Button>
          </Box>
        </div>
      </div>
    </div>
  );
};

export default BecomeSeller;